// extracted by mini-css-extract-plugin
module.exports = {"lozenge":"room__styles__lozenge___nIMaqi","close":"room__styles__close___1PlABV"};